import { AuthenticationService } from './../../../services/authentication.service';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {ToasterModule, ToasterService, Toast, ToasterConfig} from 'angular5-toaster';
import {TranslateService} from '@ngx-translate/core';
import { WebStorageService, LOCAL_STORAGE } from 'angular-webstorage-service';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-recuperarPass',
  templateUrl: './recuperarPass.component.html',
  styleUrls: ['./recuperarPass.component.scss'],
  providers: [AuthenticationService]
})
export class RecuperarPassModalComponent implements OnInit {

  username = '';
  mensaje = '';
  mostrarMensaje: boolean = false;
  respuestaS: boolean = false;
  closeResult: string;

  public toasterconfig: ToasterConfig =
  new ToasterConfig({timeout: 500});
  constructor(
    private authenticationService: AuthenticationService,
    private translate: TranslateService,
    public activeModal: NgbActiveModal,
    private toasterService: ToasterService,
    private storageService: StorageService,
    private modalService: NgbModal,
    @Inject (LOCAL_STORAGE) private storage: WebStorageService,

  ) {

  }

  ngOnInit() {
    this.noBack();
  }

  noBack() {
    history.pushState(null, null, location.href);
      window.onpopstate = function () {
          history.go(1);
      };
  }

  recuperarPass() {
  //  console.log(this.username);
    this.authenticationService.recuperarPassword(this.username,this.storage.get('LOCAL_STORAGE')).subscribe(
      data => {
        // console.log(data);
        if (data != null) {
          this.mostrarMensaje = true;

          if (data.mensaje == 'Se ha enviado un correo con sus datos de acceso.') {
            this.respuestaS = true;
          }

          this.mensaje = data.mensaje;
        }
      },
      error => {
        if (error.status === 401) {
          this.storageService.openLogout();
        } else {
          // console.log(error);
        }
       console.log(error)
       this.mostrarMensaje = true;
       this.mensaje = error.error.mensaje;

      }
    )

  }

  closeModal() {
    this.activeModal.close();
  }

  cambiarMensaje() {
    this.mostrarMensaje = !this.mostrarMensaje;
    this.username = '';
  }

}






// WEBPACK FOOTER //
// ./src/app/pages/login/recuperarPassword/recuperarPass.component.ts